import React, { Fragment } from 'react'
import { kuiperClassNames, renderIcon } from '@opallabs/kuiper'
import { colors } from '@opallabs/spectrum'
import { AccountName } from '../../../../AccountName'
import { ContentAvatar } from '../../../../ContentAvatar'
import { ScheduledTime } from '../../../../ScheduledTime'
import * as styles from './styles'
import { FacebookHeaderProps } from './types'

export const FacebookHeader: React.FC<FacebookHeaderProps> = ({
  accountImage,
  accountName,
  collabEnabled,
  collabAccount,
  location = '',
  scheduledAt,
  timezone,
}) => {
  return (
    <div css={styles.headerContainer}>
      <div css={styles.headerSubContainer}>
        {collabEnabled ? (
          <div css={styles.collabAvatarContainer}>
            <ContentAvatar assetReference={accountImage} size={40} />
            <ContentAvatar
              assetReference={null}
              size={40}
              style={styles.collabAvatarSecondary}
            />
          </div>
        ) : (
          <ContentAvatar assetReference={accountImage} size={40} />
        )}
        <div css={styles.header}>
          <div
            css={styles.accountContainer}
            className={kuiperClassNames({ [styles.withCollab]: collabEnabled })}
          >
            <AccountName
              name={accountName}
              size={14}
              style={styles.accountName(accountName)}
            />
            {collabEnabled && (
              <>
                <span css={styles.collabSeparator}> and </span>
                <AccountName
                  name={collabAccount || 'No collab account'}
                  size={14}
                  style={
                    collabAccount
                      ? styles.accountName(collabAccount)
                      : styles.emptyCollabName
                  }
                  color={collabAccount ? undefined : colors.orange.base}
                />
              </>
            )}
            {location && (
              <div css={styles.locationContainer}>
                <span> — in </span>
                <span aria-label="Content Location" css={styles.locationText}>
                  {location}
                </span>
              </div>
            )}
          </div>
          <div css={styles.scheduledTimeContainer}>
            <ScheduledTime
              css={styles.scheduledTime}
              dateFormat="MMM d"
              timestamp={scheduledAt}
              timezone={timezone}
            />
            {scheduledAt && (
              <Fragment>
                <span css={styles.scheduledTime}>at</span>
                <ScheduledTime
                  css={styles.scheduledTime}
                  dateFormat="hh:mm aaa"
                  timestamp={scheduledAt}
                  timezone={timezone}
                />
              </Fragment>
            )}
            <div css={styles.scheduledTime}>
              <span aria-hidden css={styles.scheduledTimeSeparator}>
                {' '}
                ·{' '}
              </span>
              {renderIcon('facebook-desktop-globe', {
                height: 12,
                width: 12,
                ariaMode: 'hidden',
              })}
            </div>
          </div>
        </div>
      </div>
      <div css={styles.moreIconContainer}>
        {renderIcon('facebook-mobile-story-more', {
          height: 4,
          width: 14,
          ariaMode: 'hidden',
        })}
      </div>
    </div>
  )
}
